export default __webpack_public_path__ + "static/media/lyon_king_theatre.31e6ea0c.jpg";